module.exports = [{
      plugin: require('/Users/guidovanbeek/Projects/experiments/lizard-landingpages/node_modules/gatsby-remark-images/gatsby-browser'),
      options: {"plugins":[],"maxWidth":1170,"quality":100},
    },{
      plugin: require('/Users/guidovanbeek/Projects/experiments/lizard-landingpages/node_modules/gatsby-plugin-canonical-urls/gatsby-browser'),
      options: {"plugins":[],"siteUrl":"https://gatsby-casper.netlify.com"},
    },{
      plugin: require('/Users/guidovanbeek/Projects/experiments/lizard-landingpages/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/guidovanbeek/Projects/experiments/lizard-landingpages/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-XXXX-Y","head":true,"anonymize":true,"respectDNT":true,"exclude":["/preview/**"],"sampleRate":100,"siteSpeedSampleRate":10},
    }]
